import { TourService } from '~/types/tours/costPrice';
import { CreateServicePayload, Supplier, UpdateServiceCostingPayload } from '~/types/tours/supplier';

import { json_headers, request } from './common';
import { OkResponse, stripTourPrefix, toursBasePath } from './toursApi';

export async function getSuppliers(
  params: { name?: string } = {},
  options?: { signal?: AbortSignal },
): Promise<Array<Supplier>> {
  const search = new URLSearchParams();
  if (params.name) {
    search.set('name', params.name);
  }
  const query = search.toString();

  const response: OkResponse<Array<Supplier>> = await request(
    `${toursBasePath()}/suppliers${query ? `?${query}` : ''}`,
    { method: 'GET', signal: options?.signal },
  );

  return response.result;
}

export async function getSupplier(supplierId: string, options?: { signal?: AbortSignal }): Promise<Supplier> {
  const response: OkResponse<Supplier> = await request(`${toursBasePath()}/suppliers/${supplierId}`, {
    method: 'GET',
    signal: options?.signal,
  });

  return response.result;
}

export async function getSupplierServices(
  supplierId: string,
  options?: { signal?: AbortSignal },
): Promise<Array<TourService>> {
  const response: OkResponse<Array<TourService>> = await request(
    `${toursBasePath()}/suppliers/${supplierId}/services`,
    {
      method: 'GET',
      signal: options?.signal,
    },
  );

  return response.result;
}

/** Creating the service is what links the tour to the supplier. */
export async function createService(
  supplierId: string,
  { tourId, ...payload }: CreateServicePayload,
): Promise<TourService> {
  const response: OkResponse<TourService> = await request(`${toursBasePath()}/suppliers/${supplierId}/services`, {
    method: 'POST',
    headers: json_headers,
    body: JSON.stringify({ ...payload, tourId: stripTourPrefix(tourId) }),
  });

  return response.result;
}

export async function updateServiceCosting(
  supplierId: string,
  serviceId: string,
  payload: UpdateServiceCostingPayload,
): Promise<TourService> {
  const response: OkResponse<TourService> = await request(
    `${toursBasePath()}/suppliers/${supplierId}/services/${serviceId}`,
    {
      method: 'PATCH',
      headers: json_headers,
      body: JSON.stringify(payload),
    },
  );

  return response.result;
}
